import FilterListIcon from "@mui/icons-material/FilterAlt";
import { Button } from "@mui/material";
import { useTranslation } from "hhn-commons";
import React, { useState } from "react";
import CommonDialog from "./CommonDialog/CommonDialog";
import { FilterIconButton } from "./SearchBox.style";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

interface FilterBoxProps {
  children: React.ReactNode;
  onApply?: () => void;
  onReset?: () => void;
  title: string;
  filterCount?: number;
  filterText?: React.ReactNode;
  onOpen?: () => void;
  onClose?: () => void;
}

const FilterBox = ({
  children,
  title,
  onApply,
  onReset,
  filterCount = 0,
  filterText,
  onOpen,
  onClose,
}: FilterBoxProps) => {
  const { t } = useTranslation();
  const [filterDialog, setFilterDialog] = useState(false);
  const onFilterClick = () => {
    onOpen && onOpen();
    setFilterDialog(true);
  };
  const onCloseFilterDialog = () => {
    onClose && onClose();
    setFilterDialog(false);
  };

  const onResetButton = () => {
    onReset && onReset();
    onCloseFilterDialog();
  };

  const onApplyButton = () => {
    onApply && onApply();
    onCloseFilterDialog();
  };
  return (
    <>
      <FilterIconButton aria-label="directions" onClick={onFilterClick}>
        {filterCount > 0 ? (
          <FilterListIcon
            data-testid={"filled-filter-icon"}
            sx={{ padding: "0px" }}
            color={"primary"}
          />
        ) : (
          <FilterAltOutlinedIcon
            data-testid={"outlined-filter-icon"}
            sx={{ padding: "0px" }}
            color={"secondary"}
          />
        )}
      </FilterIconButton>
      <CommonDialog
        isDialogOpen={filterDialog}
        onDialogClose={onCloseFilterDialog}
        title={title}
        actionContent={
          <>
            {onReset && (
              <Button
                autoFocus
                onClick={onResetButton}
                variant="outlined"
                data-testid="ResetFilter"
              >
                {t("filter.resetButton")}
              </Button>
            )}
            {onApply && (
              <Button
                autoFocus
                onClick={onApplyButton}
                variant="contained"
                data-testid="ApplyFilter"
              >
                {t("filter.applyButton")}
              </Button>
            )}
          </>
        }
      >
        {children && children}
      </CommonDialog>
    </>
  );
};
export default FilterBox;
